import {
  Component,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DvDialogService2 } from '@devinco/ui/dds';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  imports: [TranslateModule],
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./access-denied.component.scss'],
})
export class AccessDeniedComponent implements OnInit {
  private dialogService = inject(DvDialogService2);

  ngOnInit(): void {
    this.dialogService.closeAllDialogs();
  }
}
